var $28ea7e849d77bd1c$exports = {};
$28ea7e849d77bd1c$exports = {
  "ascending": "cresc\u0103toare",
  "ascendingSort": function ascendingSort(args) {
    return "sortate dup\u0103 coloana ".concat(args.columnName, " \xEEn ordine cresc\u0103toare");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pixeli");
  },
  "descending": "descresc\u0103toare",
  "descendingSort": function descendingSort(args) {
    return "sortate dup\u0103 coloana ".concat(args.columnName, " \xEEn ordine descresc\u0103toare");
  },
  "resizerDescription": "Ap\u0103sa\u021Bi pe Enter pentru a \xEEncepe redimensionarea",
  "select": "Selectare",
  "selectAll": "Selectare total\u0103",
  "sortable": "coloan\u0103 sortabil\u0103"
};
export { $28ea7e849d77bd1c$exports as default };